import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthorizationService } from '../../Services/authorization.service';
import { EncryptorService } from '../../Services/encryptor.service';
import { environment } from 'src/environments/environment';
import { RecaptchaComponent } from 'ng-recaptcha';
@Component({
    selector: 'app-request-restore-password',
    templateUrl: './request-restore-password.component.html',
    styleUrls: ['./request-restore-password.component.css'],
    standalone: false
})
export class RequestRestorePasswordComponent implements OnInit {
    public hole: boolean;
    public robot: boolean;

    @ViewChild('captcha') captcha: RecaptchaComponent;

    siteKey: string = environment.recaptcha.siteKey;
    formRestartPasword: UntypedFormGroup;
    constructor(
        private formBuilder: UntypedFormBuilder,
        private auth: AuthorizationService,
        private encryptorService: EncryptorService,
        private snackBar: MatSnackBar,
        public dialogRef: MatDialogRef<RequestRestorePasswordComponent>,
        @Inject(MAT_DIALOG_DATA) public darkMode: boolean,

    ) {
        this.robot = false;
    }

    ngOnInit(): void {
        this.formRestartPasword = this.formBuilder.group({
            username: ['', Validators.required],
            robot: ['', Validators.required]
        })
    }

    ngAfterViewInit() {
    }

    restartPassword() {
        this.robot = true;

        const { username } = this.formRestartPasword.value;

        this.formRestartPasword.get('username').disable();

        this.auth.resetPassword(username).subscribe(
            res => {
                this.snackBar.open(res.message, "🤖", { duration: 30000, panelClass: ['snack'] });
                this.dialogRef.close();
            }, error => {
                this.robot = false;
                this.formRestartPasword.get('robot').reset();
                this.formRestartPasword.get('username').enable();
                this.captcha.reset();
                if (error.status == 401) {
                    this.snackBar.open(error.error.error.message, "🤖", { duration: 30000, panelClass: ['snack-error-message'] });
                    this.formRestartPasword.get('username').setErrors({ 'incorrect': true }, { emitEvent: false });
                } else {
                    this.snackBar.open('Ocurrio un Error, Intente más Tarde', "🤖", { panelClass: 'snack-error-message', duration: 1500 });
                }

            }
        )

    }

    resolved(event: any) {
        if (event) {
            this.formRestartPasword.controls.robot.setValue(event);
        }
    }

    grecaptcha(event: any){
        console.log(event);
    }

}
